import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl } from '@angular/forms';

const states: string[] = [
  'AC',
  'AL',
  'AM',
  'AP',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MG',
  'MS',
  'MT',
  'PA',
  'PB',
  'PE',
  'PI',
  'PR',
  'RJ',
  'RN',
  'RO',
  'RR',
  'RS',
  'SC',
  'SE',
  'SP',
  'TO',
];

@Injectable({
  providedIn: 'root'
})
export class AddressValidatorsService {

  constructor() { }

  static forbiddenState(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {

      if (!control.dirty || /^\s*$/.test(control.value)) {
        return null;
      }

      if (!states.includes(control.value)) {
        return {'forbiddenState': {value: control.value}};
      }

      return null;
    };
  }
}
